<template>
    <div style="">
        <div style="margin:0 -12px;" v-if="is_page_init">
            <div class="container" style="height: 100%;">
                <div class="row" style="height: 100%">
                    <div class="col" style="height: 100%">
                        <div class="text-center" style="height: 100%">
                            <div class="spinner-grow" style="margin:100px 0;color:#E7E7FF;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-else-if="hasEventMember" data-testid="event-member-ticket">
            <div class="row" v-if="event_member.is_event == 4" style="background:#CDCDCD">
                <div class="col">
                    <div class="text-center" style="color:#999;padding:30px 0;font-size:22px">
                        キャンセル済み
                    </div>
                </div>
            </div>
            <div class="row" :style="setBackGroundColor()" v-else>
                <div class="col">
                    <div style="padding:20px 30px;">
                        <div class="text-center" style="color:#fff;font-size:14px;"><b>当日はこの画面を受付にお見せください</b></div>
                        <div class="text-center" style="color:#fff;font-size:12px;">スムーズな入場へのご協力お願いいたします</div>
                        <br>
                        <div class="ticket_backimage" style="margin: 0 -10px;padding: 0 12px;background-color:#fff">
                            <div class="row">
                                <div class="col px-0">
                                    <div style="padding:15px;">
                                        <img :src="event.img_url" class="img-fluid" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-1 px-0">
                                    <div style="padding-top: 80px">
                                        <div>
                                            <div :class="setTriangle()"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col px-0">
                                    <table class="table table-borderless">
                                        <tr>
                                            <td valign="top">
                                                <div class="text-center">
                                                    <div
                                                        style="color:#6B4EFF;font-size:14px">
                                                        Name
                                                    </div>
                                                    <div>
                                                        {{ event_member.name }}
                                                    </div>
                                                </div>
                                            </td>
                                            <td rowspan="2" valign="top">
                                                <div class="text-center">
                                                    <div
                                                        style="color:#6B4EFF;font-size:14px">
                                                        Receipt number
                                                    </div>
                                                    <div style="font-size:50px;">
                                                        {{ event_member.id }}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <div class="text-center">
                                                    <div
                                                        style="color:#6B4EFF;font-size:14px">
                                                        Sexual preference
                                                    </div>
                                                    <div v-if="event_member.type == 1">
                                                        S
                                                    </div>
                                                    <div v-else-if="event_member.type == 2">
                                                        M
                                                    </div>
                                                    <div v-else>
                                                        スイッチャー
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <div class="text-center">
                                                    <div
                                                        style="color:#6B4EFF;font-size:14px">
                                                        Seat type
                                                    </div>
                                                    <div>
                                                        <div v-if="event_member.seat_type == 0">
                                                            通し
                                                        </div>
                                                        <div v-else-if="event_member.seat_type == 1">
                                                            １部
                                                        </div>
                                                        <div v-else-if="event_member.seat_type == 2">
                                                            ２部
                                                        </div>
                                                        <div v-else-if="event_member.seat_type == 3">
                                                            ３部
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td valign="top">
                                                <div class="text-center">
                                                    <div
                                                        style="color:#6B4EFF;font-size:14px">
                                                        Seat number
                                                    </div>
                                                    <div>
                                                        <div v-if="event_member.desk_number == null">
                                                            未決定
                                                        </div>
                                                        <div v-else>
                                                            {{ event_member.desk_number }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-1 px-0">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col px-0">
                                    <img src="/images/image136.png" class="img-fluid" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div v-if="event_member.is_event == 2">
                                        <div class="text-center"
                                            style="background: #E6E6E6;padding: 5px;font-size: 14px;font-weight: 600;">
                                            当日決済（現金のみ）</div>
                                        <div class="text-center" style="padding: 5px;font-size: 28px;font-weight: 600;">

                                            <div v-if="event_member.sex == 1 && event_member.seat_type == 1">{{
                                                event.amount7 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span>
                                            </div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 2">{{
                                                event.amount11 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 3">{{
                                                event.amount15 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 0">{{
                                                event.amount19 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 9">{{
                                                event.amount3 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 1">{{
                                                event.amount8 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 2">{{
                                                event.amount12 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 3">{{
                                                event.amount16 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 0">{{
                                                event.amount20 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 9">{{
                                                event.amount4 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>

                                        </div>
                                    </div>
                                    <div v-if="event_member.is_event == 1">
                                        <div class="text-center"
                                            style="background: #E6E6E6;padding: 5px;font-size: 14px;font-weight: 600;">
                                            事前決済
                                        </div>
                                        <div class="text-center" style="padding: 5px;font-size: 28px;font-weight: 600;">予約済
                                        </div>
                                    </div>
                                    <div v-if="event_member.is_event == 0">
                                        <div class="text-center"
                                            style="background: #E6E6E6;padding: 5px;font-size: 14px;font-weight: 600;">
                                            事前決済（未決済）</div>
                                        <div class="text-center" style="padding: 5px;font-size: 28px;font-weight: 600;">
                                            <div v-if="event_member.sex == 1 && event_member.seat_type == 1">{{
                                                event.amount5 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span>
                                            </div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 2">{{
                                                event.amount9 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 3">{{
                                                event.amount13 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 0">{{
                                                event.amount17 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 1 && event_member.seat_type == 9">{{
                                                event.amount1 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 1">{{
                                                event.amount6 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 2">{{
                                                event.amount10 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 3">{{
                                                event.amount14 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 0">{{
                                                event.amount18 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                            <div v-else-if="event_member.sex == 2 && event_member.seat_type == 9">{{
                                                event.amount2 |
                                                priceLocaleString
                                            }}<span style="font-size:20px">円</span></div>
                                        </div>
                                    </div>
                                    <div class="text-center" style="padding-bottom:20px;">
                                        <img src="/images/code39hino.png" class="img-fluid" style="height:20px;width:100%;"
                                            v-if="kuji == 1" />
                                        <img src="/images/code39umeko.png" class="img-fluid" style="height:20px;width:100%;"
                                            v-else-if="kuji == 2" />
                                        <img src="/images/code39atari.png" class="img-fluid" style="height:20px;width:100%;"
                                            v-else-if="kuji == 3" />
                                        <img src="/images/code39hazure.png" class="img-fluid"
                                            style="height:20px;width:100%;" v-else-if="kuji == 4" />
                                        <img src="/images/code39.png" class="img-fluid" style="height:20px;width:100%;"
                                            v-else />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="font-size:10px;color:#fff;">
                        ● イベント当日は混み合いインターネットに接続しづらい場合がございます。<br />
                        ● このチケット部分（お名前・性別・性癖・席番号）までスクリーンショットした上で受付に提示いただけると、よりスムーズにご案内いただけます。<br /><br />
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="row">
                                    <div class="col-3">
                                        <div style="float:left">
                                            <img :src="event.img_url" class="thumbnail-box" />
                                        </div>
                                    </div>
                                    <div class="col px-0">
                                        <div style="padding-left:10px;">
                                            <div style="color:#6B4EFF;font: size 14px;">{{ event.thumbnail }}</div>

                                            <div style="display:flex">
                                                <div style="padding-right:5px">
                                                    <i class="bi bi-clock"
                                                        style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                </div>
                                                <div>
                                                    <div v-if="event.event_type == 1">
                                                        <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                            1部　{{
                                                                event.event_at_from_text_1
                                                            }}〜{{ event.event_at_to_text_1 }}</div>
                                                        <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                            2部　{{
                                                                event.event_at_from_text_2
                                                            }}〜{{ event.event_at_to_text_2 }}</div>
                                                    </div>
                                                    <div v-if="event.event_type == 2">
                                                        <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                            1部　{{
                                                                event.event_at_from_text_1
                                                            }}〜{{ event.event_at_to_text_1 }}</div>
                                                        <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                            2部　{{
                                                                event.event_at_from_text_2
                                                            }}〜{{ event.event_at_to_text_2 }}</div>
                                                        <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                            3部　{{
                                                                event.event_at_from_text_3
                                                            }}〜{{ event.event_at_to_text_3 }}</div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                            {{
                                                                event.event_at_from_text
                                                            }}〜{{ event.event_at_to_text }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="display:flex">
                                                <div style="padding-right:5px">
                                                    <i class="bi bi-geo-alt"
                                                        style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                </div>
                                                <div>
                                                    <div class="" style="color:#777;font-size:12px;padding-bottm:5px;">
                                                        {{ event.address }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            名前
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">{{ event_member.name }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            性別
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div v-if="event_member.sex == 1" style="font-size:14px;">
                                            女性
                                        </div>
                                        <div v-else style="font-size:14px;">
                                            男性
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            性癖
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div v-if="event_member.type == 1" style="font-size:14px;">
                                            S
                                        </div>
                                        <div v-else-if="event_member.type == 2" style="font-size:14px;">
                                            M
                                        </div>
                                        <div v-else style="font-size:14px;">
                                            スイッチャー
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            受付番号
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">{{ event_member.id }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            席番号
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">
                                            <div v-if="event_member.desk_number == null">
                                                未決定
                                            </div>
                                            <div v-else>
                                                {{ event_member.desk_number }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            メールアドレス
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">{{ event_member.mail }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            電話番号
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">{{ event_member.tel }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            費用
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">
                                            <div v-if="event_member.is_event == 2">
                                                <div v-if="event_member.sex == 1 && event_member.seat_type == 1">当日決済 {{
                                                    event.amount7 |
                                                    priceLocaleString }}円
                                                </div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 2">当日決済
                                                    {{ event.amount11 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 3">当日決済
                                                    {{ event.amount15 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 0">当日決済
                                                    {{ event.amount19 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 9">当日決済
                                                    {{ event.amount3 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 1">当日決済
                                                    {{ event.amount8 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 2">当日決済
                                                    {{ event.amount12 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 3">当日決済
                                                    {{ event.amount16 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 0">当日決済
                                                    {{ event.amount20 |
                                                        priceLocaleString
                                                    }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 9">当日決済
                                                    {{ event.amount4 |
                                                        priceLocaleString
                                                    }}円</div>
                                            </div>
                                            <div v-else-if="event_member.is_event == 0">
                                                <div v-if="event_member.sex == 1 && event_member.seat_type == 1">{{
                                                    event.amount5 |
                                                    priceLocaleString }}円
                                                </div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 2">{{
                                                    event.amount9 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 3">{{
                                                    event.amount13 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 0">{{
                                                    event.amount17 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 1 && event_member.seat_type == 9">{{
                                                    event.amount1 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 1">{{
                                                    event.amount6 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 2">{{
                                                    event.amount10 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 3">{{
                                                    event.amount14 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 0">{{
                                                    event.amount18 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div v-else-if="event_member.sex == 2 && event_member.seat_type == 9">{{
                                                    event.amount2 |
                                                    priceLocaleString
                                                }}円</div>
                                                <div style="padding:5px 0;">
                                                </div>
                                            </div>
                                            <div v-else-if="event_member.is_event == 1">
                                                決済完了
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="event_member.is_event == 0">
                                    <div class="col" style="padding:8px 20px;">
                                        <div class="text-center" style="color:red">
                                            <b v-if="isPrepaymentOnly">支払期限までに決済が完了しない場合、<br>ご予約は自動的にキャンセルされます。</b>
                                            <b v-else>期日までにお支払いがない場合<br>予約状態のまま当日決済へ自動移行します。</b>
                                        </div>
                                        <div class="row justify-content-center">
                                            <div class="col-11" style="padding:10px 20px;">
                                                <div class="d-grid gap-2" style="padding: 0 5px" v-if="url">
                                                    <a :href="url" type="button" class="btn btn-luna"
                                                        style="font-size: 18px; padding: 12px 0" target="_blank"
                                                        data-testid="payment-link">
                                                        お支払い
                                                        <div v-if="event.deadline_at_text" style="font-size: 11px;">
                                                            <small>支払い期限：{{ event.deadline_at_text }}</small>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-5" style="padding:5px 20px;">
                                        <div style="color:#6B4EFF;font-size:14px;padding-bottom:5px;">
                                            申込出演者
                                        </div>
                                    </div>
                                    <div class="col" style="padding:5px;">
                                        <div style="font-size:14px;">{{ event_member.player_name }}</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col" style="padding:8px 20px;">
                                        <div style="border-bottom:1px solid #E6E6E6;"></div>
                                    </div>
                                </div>
                                <div class="row justify-content-center" v-if="isEventEnd(event.event_at_to)">
                                    <div class="col-11 text-center" style="padding:10px 20px;color:#777;">
                                        イベントは終了しました。
                                    </div>
                                </div>
                                <div class="row justify-content-center"
                                    v-else-if="event_member.is_event == 4 && !isPrepaymentOnlyRegistrationClosed">
                                    <div class="col-11" style="padding:10px 20px;">
                                        <div class="d-grid gap-2" style="padding: 0 5px">
                                            <a type="button" class="btn btn-luna" style="font-size: 18px; padding: 12px 0"
                                                :href="'/event/re/recruit/' + event.id">
                                                再申し込み
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center" v-else-if="event_member.is_event == 4">
                                    <div class="col-11 text-center" style="padding:10px 20px;color:#777;"
                                        data-testid="prepayment-only-registration-closed">
                                        支払期限を過ぎたため、再申し込みできません。
                                    </div>
                                </div>
                                <div class="row justify-content-center" v-else-if="event_member.is_event != 1">
                                    <div class="col-11" style="padding:10px 20px;">
                                        <div class="d-grid gap-2" style="padding: 0 5px">
                                            <button type="button" class="btn btn-luna"
                                                style="font-size: 18px; padding: 12px 0"
                                                v-if="canChangePaymentToPrepayment"
                                                :disabled="is_changing_payment"
                                                @click="changePaymentToPrepayment()">
                                                {{ is_changing_payment ? "変更中..." : "事前決済へ変更" }}
                                            </button>
                                            <button type="button" class="btn btn-luna-d"
                                                style="font-size: 18px; padding: 12px 0" @click="setCancel()">
                                                予約をキャンセル
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
        </div>
        <div class="wrap" v-else data-testid="event-member-empty">
            <div class="row">
                <div class="col">
                    <div class="text-center" style="padding:40px 20px;color:#6B4EFF;"
                        data-testid="event-member-empty-message">
                        イベント申込情報が見つかりません。
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-11" style="padding:10px 20px;">
                            <div class="d-grid gap-2" style="padding: 0 5px">
                                <a type="button" class="btn btn-luna" style="font-size: 18px; padding: 12px 0"
                                    data-testid="event-member-empty-detail-link"
                                    :href="'/event/details/' + $route.params['eid']">
                                    イベント詳細へ
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
        </div>
        <div class="row" style="background:#E5E0FE;" v-if="hasEventMember && event_member.is_event == 1">
            <div class="col">
                <div style="padding:0 10px;">
                    <div class="row">
                        <div class="col">
                            <br />
                            <small style="color:#6B4EFF;font-size:12px;">
                                注意事項<br>
                                ■ 決済完了後のチケットのキャンセルはできません。<br>
                            </small>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>
        <div class="row" style="background:#E5E0FE;" v-if="hasEventMember && event_member.is_event == 4">
            <div class="col">
                <div style="padding:0 10px;">
                    <div class="row">
                        <div class="col">
                            <br />
                            <small style="color:#6B4EFF;font-size:12px;">
                                注意事項<br>
                                <template v-if="isPrepaymentOnlyRegistrationClosed">
                                    支払期限を過ぎたため、再申し込みできません。<br>
                                </template>
                                <template v-else-if="isPrepaymentOnly">
                                    申込期限前であれば、再申し込み時に事前決済を選択できます。<br>
                                </template>
                                <template v-else-if="event.owner_status == 1">
                                    申込期限前であれば、再申し込み時に事前決済または当日決済を選択できます。<br>
                                </template>
                                <template v-else>
                                    再申し込み時は当日決済を選択できます。<br>
                                </template>
                            </small>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>
        <div style="margin:0 -12px;background:#6B4EFF;">
            <Footer></Footer>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
import { clearPageStorage } from '../../event-log/clearPageStorage';
import Footer from './../Footer.vue'
import {
    isPrepaymentOnlyEvent,
    isPrepaymentRegistrationClosed,
} from './paymentOptions';
export default {
    data() {
        return {
            event: [],
            event_member: [],
            is_auth: false,
            is_recruit: true,
            member_count: 0,
            user: [],
            tel: "",
            email: "",
            is_tel_error: false,
            is_email_error: false,
            is_changing_payment: false,
            sexs: [
                { value: "1", label: "女性" },
                { value: "2", label: "男性" },
            ],
            sex: [],
            types: [
                { value: "1", label: "S" },
                { value: "2", label: "M" },
                { value: "3", label: "スイッチャー" },
            ],
            type: [],
            comment: "",
            url: "",
            is_page_init: true,
            kuji: 0,
        };
    },
    computed: {
        // 未申込時は API が null を返す。初期値は既存画面に合わせて [] のため両方を未申込として扱う
        hasEventMember() {
            const member = this.event_member

            if (member === null || member === undefined) {
                return false
            }

            return Array.isArray(member) ? member.length > 0 : true
        },
        isPrepaymentOnly() {
            return isPrepaymentOnlyEvent(this.event);
        },
        isPrepaymentOnlyRegistrationClosed() {
            return this.isPrepaymentOnly
                && isPrepaymentRegistrationClosed(this.event);
        },
        canChangePaymentToPrepayment() {
            return this.event_member.is_event == 2
                && this.event.owner_status == 1
                && !this.event.is_deadline
                && !this.isPrepaymentOnlyRegistrationClosed;
        },
    },
    methods: {
        async fetchEvent() {
            await axios
                .get("/api/event/show/" + this.$route.params["eid"])
                .then((response) => {
                    this.event = response.data.event;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                });

            let response_auth = await axios.get("/api/user/is_auth");
            this.is_auth = response_auth.data.is_atuh;

            if (this.is_auth) {

                let _date = localStorage.getItem('luna_last_at')
                let _uid = localStorage.getItem('luna_uid')

                clearPageStorage();

                localStorage.setItem('luna_last_at', _date)
                localStorage.setItem('luna_uid', _uid)

                await axios
                    .get("/api/event/member/" + this.$route.params["eid"])
                    .then((response) => {
                        this.user = response.data.user;
                        this.event_member = response.data.event_member;
                        this.tel = this.user.tel;
                        this.email = this.user.email;
                        this.member_count = response.data.member_count;
                        this.url = response.data.payment_url;
                    });
            } else {
                localStorage.setItem("redirect", this.$route.path);
                window.location.href = "/auth?logout=true"
            }

            this.is_page_init = false
        },
        async setCancel() {
            let ans = true;

            ans = confirm("本当にイベント申し込みをキャンセルしますか？");

            if (ans) {
                await axios
                    .post("/api/event/cancel", {
                        uid: this.user.id,
                        eid: this.event.id,
                    })
                    .then((response) => {
                        window.location.href = "/event/cancel";
                    })
                    .catch((error) => {
                        if (error.response && error.response.status == 401) {
                            window.location.href = "/auth?logout=true"
                        }
                        else {
                            this.$showErrorToast("キャンセルに失敗しました")
                        }
                    });
            }
        },
        async changePaymentToPrepayment() {
            if (this.is_changing_payment) {
                return;
            }

            const ans = confirm(
                "事前決済へ変更しますか？変更後は申込情報ページから支払期限までにお支払いください。"
            );

            if (!ans) {
                return;
            }

            this.is_changing_payment = true;

            try {
                await axios.post("/api/event/payment/prepayment", {
                    eid: this.event.id,
                });

                window.location.reload();
            } catch (error) {
                const status = error.response ? error.response.status : null;

                if (status == 401) {
                    window.location.href = "/auth?logout=true";
                } else if (status == 422) {
                    this.$showErrorToast("申込期限または申込内容をご確認ください");
                } else if (status == 409) {
                    this.$showErrorToast("申込状態が更新されています。ページを再読み込みしてください");
                } else {
                    this.$showErrorToast("事前決済への変更に失敗しました");
                }
            } finally {
                this.is_changing_payment = false;
            }
        },
        setRedirect() {
            localStorage.setItem("redirect", this.$route.path);
            window.location.href = "/auth";
        },
        setBackGroundColor() {
            if (this.event_member.type == 1) {
                return 'background-color:#1DA1F2'
            }
            else if (this.event_member.type == 2) {
                return 'background-color:#FF6D6D'
            }
            else {
                return 'background-color:#F6BF30'
            }
        },
        setTriangle() {
            if (this.event_member.type == 1) {
                return 'triangle1'
            }
            else if (this.event_member.type == 2) {
                return 'triangle2'
            }
            else {
                return 'triangle3'
            }
        },
        isEventEnd(event) {
            if (event == undefined) {
                return false
            }

            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            return (eDate < today);
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.kuji = Math.floor(Math.random() * 11)
                            this.fetchEvent();
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.kuji = Math.floor(Math.random() * 11)
                this.fetchEvent();
            }
        }
        else {
            this.kuji = Math.floor(Math.random() * 11)
            this.fetchEvent();
        }
    },
    filters: {
        priceLocaleString(value) {
            if (value != undefined) {
                return value.toLocaleString();
            } else {
                return value;
            }
        },
    },
    components: {
        Footer: Footer,
    }
};
</script>
<style scoped>@import url('https://fonts.googleapis.com/css2?family=Alex+Brush&family=MuseoModerno:wght@500&display=swap');

.triangle1 {
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid #1DA1F2;
}

.triangle2 {
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid #FF6D6D;
}

.triangle3 {
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid #F6BF30;
}

.ticket_backimage {
    background-image: url('/images/event_ticket_back.png');
    background-size: cover;
    background-position: center;
}

.thumbnail-box {
    width: 80px;
    height: 80px;
    object-fit: none;
    object-position: 50% 50%;
    border-radius: 10px;
}</style>
